"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var orderListApi = _interopRequireWildcard(require("@/api/orderListApi.js"));
var _transformState = _interopRequireDefault(require("@/utils/transformState.js"));
var _logDetail = _interopRequireDefault(require("./logDetail.vue"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'thirdOrderDetail',
  components: {
    LogDetail: _logDetail.default
  },
  props: {
    orderId: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      dialogVisible: false,
      orderDatalist: {},
      loading: false,
      baseOption: [
      // 订单基础信息
      {
        title: '订单编号',
        dataIndex: 'orderNo'
      }, {
        title: '客户单号',
        dataIndex: 'housekeepingOrderNo'
      }, {
        title: '订单状态',
        dataIndex: 'statusName'
      }, {
        title: '三方订单状态',
        dataIndex: 'thirdPartyStatusDesc'
      }, {
        title: '产品名称',
        dataIndex: 'skuName'
      }, {
        title: '规格',
        dataIndex: 'skuAttr'
      }, {
        title: '预约时间',
        dataIndex: 'appointmentTime'
      }, {
        title: '地址',
        dataIndex: 'address'
      }, {
        title: '备注',
        dataIndex: 'housekeepingRemark'
      }, {
        title: '订单金额',
        dataIndex: 'totalPrice'
      }, {
        title: '供应商扣费',
        dataIndex: 'supplierPrice'
      }, {
        title: '创建时间',
        dataIndex: 'createTime'
      }],
      orderNo: null,
      needRefreshList: 0 // 关闭时是否需要刷新列表 0:不需要 1:需要
    };
  },
  mounted: function mounted() {},
  methods: {
    transformState: _transformState.default,
    openDetail: function openDetail(orderNo) {
      this.orderNo = orderNo;
      this.needRefreshList = 0;
      if (!orderNo) {
        this.$message.warning('未查询到该订单！');
        return;
      }
      this.getOrderData();
    },
    // 获取订单物流信息
    getOrderData: function getOrderData() {
      var _this = this;
      var needRefreshList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      this.needRefreshList = needRefreshList;
      this.dialogVisible = true;
      this.loading = true;
      orderListApi.getOrderDetail(this.orderNo).then(function (res) {
        var _ref = res || {},
          _ref$orderItemList = _ref.orderItemList,
          orderItemList = _ref$orderItemList === void 0 ? [] : _ref$orderItemList,
          _ref$orderPay = _ref.orderPay,
          orderPay = _ref$orderPay === void 0 ? {} : _ref$orderPay;
        _this.orderDatalist = _objectSpread(_objectSpread(_objectSpread({}, res), (orderItemList === null || orderItemList === void 0 ? void 0 : orderItemList[0]) || {}), orderPay);
        _this.loading = false;
      }).catch(function (err) {
        _this.loading = false;
      });
    },
    // 关闭弹窗，判断是否需要刷新列表
    handleColse: function handleColse() {
      this.needRefreshList == 1 && this.$emit('doRefresh');
      this.dialogVisible = false;
    },
    // 查看日志详情
    openReqDetail: function openReqDetail(row) {
      this.$refs['LogDetailRef'].openInit(row);
    },
    syncHousekeepingStatus: function syncHousekeepingStatus() {
      var _this2 = this;
      if (!this.orderNo) return;
      this.loading = true;
      orderListApi.syncHousekeepingStatus(this.orderNo).then(function (res) {
        _this2.loading = false;
        _this2.$message.success('同步成功！');
        _this2.getOrderData();
      }).catch(function (err) {
        _this2.loading = false;
      });
    }
  }
};